import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import LatestEpisode from '../components/latest-episode';
import RecentEpisodes from '../components/recent-episodes';
import TopCategories from '../components/top-categories';

export default function Home() {
  return (
    <Layout>
      <SEO title="Books mentioned on the Lex Fridman Podcast" />
      <LatestEpisode />
      <RecentEpisodes />
      <TopCategories />
    </Layout>
  );
}
